<template>
  <div class="login">
    <backHeader back-addr="/person"></backHeader>
    <!-- <div class="head"><img src="../assets/logo.png" alt=""></div> -->
    <div class="formItem" style="margin-top:120px;">
      <mt-field label="学号" v-model="login_usernumber" placeholder="学号"></mt-field>
      <mt-field label="姓名" v-model="login_username" placeholder="姓名"></mt-field>
      <!-- <mt-field label="密码" placeholder="密码" type="password" v-model="login_password"></mt-field> -->
      <!-- <mt-field label="" v-model="login_username" :state="state" disableClear placeholder="用户名"></mt-field>
      <mt-field label="" placeholder="密码"  :state="statePas" type="password" disableClear v-model="login_password"></mt-field> -->
      <div class="subBut" @click="login">登录</div>
      <div class="more">
        <!-- <router-link :to="{'path':'/register'}" class="register">注册 ></router-link> -->
        <!-- <router-link :to="{'path':'/login'}" class="forgetPass">忘记密码？</router-link> -->
      </div>
    </div>
    <!-- <div class="otherLonin">
      <div class="title"><span>第三方平台</span></div>
      <div class="cont">
        <div><img src="../assets/QQlog.png" alt=""></div>
        <div><img src="../assets/weix.png" alt=""></div>
      </div>
    </div> -->
  </div>
</template>
<script>
import backHeader from "./../components/back-header.vue";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import logApi from "../api/users";
import { Toast, MessageBox } from "mint-ui";
import Qs from "qs";
export default {
  name: "login",
  data() {
    return {
      login_username: "", //用户名
      login_usernumber: "", //学号
      // username:'15116921213',
      // password:'111111',
      state: "success",
      statePas: "success"
    };
  },
  methods: {
    isDesktop() {
      try {
        mui;
        return "app";
      } catch (error) {
        console.log("plus not");
      }
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return "mobile";
      } else {
        return "pc";
      }
    },
    login() {
      if (this.login_usernumber.length < 4 || this.login_username == "") {
        MessageBox.alert("学号或者姓名存在错误！", "提示");
        return;
      }
      axios
        .post(
          Addr.getGoNewAPIPrefix() + "user/login",
          Qs.stringify({
            username: this.login_username,
            usernumber: this.login_usernumber,
            type: this.isDesktop()
          })
        )
        .then(res => {
          if (res.data.returnCode == 104) {
            console.log("login success");

            let userId = res.data.returnData.split(",")[0];
            let userRole = res.data.returnData.split(",")[1];
            let userNumber = res.data.returnData.split(",")[2];

            console.log("userId is:");
            console.log(userId);
            console.log(userRole);
            console.log(userNumber);

            this.$store.commit("updateUserId", userId);
            this.$store.commit("updateUserNumber", userNumber);
            console.log(this.$store.state.mineStore.userId);
            this.$store.commit("updateUserName", this.login_username);
            this.$store.commit("updateRole", userRole);
            this.$store.commit("updateIsLogin", true);
            this.$store.commit("updateLoginTime", Date.parse(new Date()));

            this.$router.push({
              path: "/person"
            });
          } else if (res.data.returnCode == 101) {
            MessageBox.alert("密码错误！", "提示");
          } else if (res.data.returnCode == 103) {
            MessageBox.alert("用户不存在！", "提示");
          } else if (res.data.returnCode == 102) {
            MessageBox.alert("用户id不存在！", "提示");
          } else if (res.data.returnCode == 105) {
            MessageBox.alert("学号或者姓名存在错误！", "提示");
          }
        })
        .catch(err => {
          Toast({
            message: "登录出现异常！",
            position: "bottom",
            duration: 800
          });
          console.log("login failed");
          console.log(err);
        });
    }
  },
  watch: {
    // username(val, oldval){
    //   if(/^1[34578]\d{9}$/.test(val)){
    //     this.state = 'success'
    //   }else{
    //     this.state = 'warning'
    //   }
    // },
    // password(val, oldval){
    //   if(/^[A-Za-z0-9]{6,18}$/.test(val)){
    //     this.statePas = 'success'
    //   }else{
    //     this.statePas = 'warning'
    //   }
    // }
  },
  mounted: function() {},
  components: {
    backHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.login {
  .head {
    text-align: center;
    padding: 70px;
    img {
      width: 70%;
    }
  }
  .formItem {
    font-size: 18px;
    margin: 0 30px;
    .mint-cell {
      background: transparent;
    }
    .mint-cell-wrapper {
      background: transparent;
      padding: 0;
      border-bottom: solid 1px $cl14;
    }
    .subBut {
      background: $cl0;
      color: $cl1;
      text-align: center;
      line-height: 40px;
      margin: 20px 0;
    }
    .more {
      display: flex;
      text-align: center;
      .register {
        color: $cl0;
        flex: 1;
      }
      .forgetPass {
        color: $cl9;
        flex: 1;
      }
    }
  }
  .otherLonin {
    text-align: center;
    position: relative;
    bottom: 0;
    width: 84%;
    top: 20px;
    left: 8%;
    margin: 20px 0;
    .title {
      border-bottom: solid 1px $cl14;
      position: relative;
      color: $cl9;
      span {
        background: $cl10;
        position: relative;
        display: inline-block;
        padding: 0 20px;
        top: 12px;
      }
    }
    .cont {
      margin: 30px 0px;
      position: relative;
      width: 70%;
      left: 15%;
      display: flex;
      div {
        flex: 1;
      }
      img {
        width: 40%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-my/login.vue